import { useState } from "react";
import { FaGithub, FaLinkedinIn, FaQuora, FaTelegram, FaWhatsapp, FaFacebookF } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";

const links = [
  {
    id: 1,
    label: "LinkedIn",
    icon: <FaLinkedinIn size={19} />,
    href: "https://www.linkedin.com/in/ali-mohammad-sohel-rana-377050216/",
    gradient: "linear-gradient(135deg, #0B77C2, #2563EB)",
    glow: "rgba(37, 99, 235, 0.55)",
  },
  {
    id: 2,
    label: "GitHub",
    icon: <FaGithub size={20} />,
    href: "https://github.com/rana16468/",
    gradient: "linear-gradient(135deg, #3b4252, #111827)",
    glow: "rgba(148, 163, 184, 0.45)",
  },
  {
    id: 3,
    label: "Email",
    icon: <HiOutlineMail size={21} />,
    href: "mailto:rana16-468@diu.edu.bd",
    gradient: "linear-gradient(135deg, #F05252, #C0392B)",
    glow: "rgba(240, 82, 82, 0.55)",
  },
  {
    id: 4,
    label: "Facebook",
    icon: <FaFacebookF size={18} />,
    href: "https://www.facebook.com/amsohel.rana.90",
    gradient: "linear-gradient(135deg, #1877F2, #1558C0)",
    glow: "rgba(24, 119, 242, 0.55)",
  },
  {
    id: 5,
    label: "Quora",
    icon: <FaQuora size={19} />,
    href: "https://www.quora.com/profile/A-M-S-R",
    gradient: "linear-gradient(135deg, #D63A36, #8E1E1B)",
    glow: "rgba(214, 58, 54, 0.55)",
  },
  {
    id: 6,
    label: "WhatsApp",
    icon: <FaWhatsapp size={21} />,
    href: "https://wa.me/8801884557649",
    gradient: "linear-gradient(135deg, #2EE07A, #128C7E)",
    glow: "rgba(37, 211, 102, 0.55)",
  },
  {
    id: 7,
    label: "Telegram",
    icon: <FaTelegram size={21} />,
    href: "https://t.me/+8801722305054",
    gradient: "linear-gradient(135deg, #2FB4EC, #0E76A8)",
    glow: "rgba(34, 158, 217, 0.55)",
  },
];

const TILE = 44; // icon tile size (px)
const OPEN = 172; // expanded width (px)

const SocialLinks = () => {
  // index of the hovered / focused link, or null
  const [active, setActive] = useState(null);

  return (
    <nav
      aria-label="Social links"
      className="hidden lg:block fixed left-4 top-1/2 -translate-y-1/2 z-50"
    >
      {/* Glass dock */}
      <div
        className="relative flex flex-col items-start gap-2 p-2 rounded-[22px] border border-white/10 backdrop-blur-xl"
        style={{
          width: TILE + 16,
          background:
            "linear-gradient(180deg, rgba(30,41,59,0.88), rgba(15,23,42,0.92))",
          boxShadow:
            "0 18px 50px rgba(2,6,23,0.45), inset 0 1px 0 rgba(255,255,255,0.08)",
        }}
      >
        {links.map(({ id, label, icon, href, gradient, glow }, i) => {
          // distance from the hovered item drives a dock-style ripple
          const dist = active === null ? null : Math.abs(active - i);
          const isActive = dist === 0;
          const isNeighbor = dist === 1;

          return (
            <a
              key={id}
                href={href}
              aria-label={label}
              target={"_blank"}
                rel="noreferrer"
              onMouseEnter={() => setActive(i)}
              onMouseLeave={() => setActive(null)}
              onFocus={() => setActive(i)}
              onBlur={() => setActive(null)}
              className="relative flex items-center rounded-[14px] text-white no-underline whitespace-nowrap overflow-hidden outline-none focus-visible:ring-2 focus-visible:ring-white motion-reduce:!transition-none"
              style={{
                height: TILE,
                width: isActive ? OPEN : TILE,
                background: gradient,
                transform: `translateX(${isActive ? 12 : isNeighbor ? 5 : 0}px)`,
                boxShadow: isActive
                  ? `0 10px 28px ${glow}, inset 0 1px 0 rgba(255,255,255,0.35)`
                  : "0 2px 6px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.2)",
                transition:
                  "width .38s cubic-bezier(.34,1.3,.64,1), transform .3s cubic-bezier(.34,1.4,.64,1), box-shadow .3s ease",
                zIndex: isActive ? 2 : 1,
              }}
            >
              {/* Glossy sheen */}
              <span
                aria-hidden
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(115deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0) 45%)",
                  opacity: isActive ? 1 : 0.6,
                  transition: "opacity .3s ease",
                }}
              />

              {/* Icon tile */}
              <span
                className="relative flex items-center justify-center flex-shrink-0 motion-reduce:!transition-none"
                style={{
                  width: TILE,
                  height: TILE,
                  transform: isActive
                    ? "scale(1.15) rotate(-8deg)"
                    : "scale(1) rotate(0deg)",
                  transition: "transform .3s cubic-bezier(.34,1.6,.64,1)",
                }}
              >
                {icon}
              </span>

              {/* Label */}
              <span
                className="relative text-[14px] font-semibold tracking-wide pr-4 motion-reduce:!transition-none"
                style={{
                  opacity: isActive ? 1 : 0,
                  transform: `translateX(${isActive ? 0 : -8}px)`,
                  transition: "opacity .2s ease .08s, transform .3s ease .05s",
                  textShadow: "0 1px 2px rgba(0,0,0,0.25)",
                }}
              >
                {label}
              </span>
            </a>
          );
        })}
      </div>
    </nav>
  );
};

export default SocialLinks;